module.exports = __webpack_public_path__ + "static/media/kovani-elementi.f61bb76b.png";